/* Native controllers for the approved shared Ainaz shell. No framework runtime. */
(function () {
  'use strict';
  function init(root) {
    root.querySelectorAll('[data-shell-announcement]').forEach(function (bar) {
      if (bar.dataset.shellInit) return;
      if (bar._disposeAnnouncement) { bar._disposeAnnouncement(); delete bar._disposeAnnouncement; }
      bar.dataset.shellInit = '1';
      bar.dataset.init = '1';
      var items = Array.from(bar.querySelectorAll('[data-announcement-item]'));
      var previous = bar.querySelector('[data-announcement-prev]');
      var next = bar.querySelector('[data-announcement-next]');
      var toggle = bar.querySelector('[data-announcement-pause]');
      var live = bar.querySelector('[aria-live]');
      var current = 0, playing = bar.dataset.autoplay === 'true', timer;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var animations = [], revision = 0, cleanups = [];
      function on(node, type, handler) { if (!node) return; node.addEventListener(type, handler); cleanups.push(function () { node.removeEventListener(type, handler); }); }
      function stop() { window.clearInterval(timer); }
      function settle() {
        revision++;
        animations.forEach(function (animation) { animation.cancel(); }); animations = [];
        items.forEach(function (item, index) {
          item.hidden = index !== current; item.inert = index !== current;
          item.setAttribute('aria-hidden', String(index !== current));
          item.classList.toggle('is-active', index === current);
        });
        bar.dataset.announcementState = 'settled';
      }
      function show(index, direction) {
        if (!items.length) return;
        var before = current, target = (index + items.length) % items.length;
        if (before === target) return;
        var outgoing = items[before], incoming = items[target];
        var fromOut = {opacity: getComputedStyle(outgoing).opacity, transform: getComputedStyle(outgoing).transform};
        var fromIn = incoming.hidden ? {opacity: 0, transform: 'translateY(' + (direction * 8) + 'px)'} : {opacity: getComputedStyle(incoming).opacity, transform: getComputedStyle(incoming).transform};
        current = target; settle();
        if (reduce.matches || document.body.dataset.animations === 'false' || !incoming.animate) return;
        var version = ++revision;
        outgoing.hidden = false; outgoing.inert = true; outgoing.setAttribute('aria-hidden', 'true');
        bar.dataset.announcementState = 'transitioning';
        animations = [
          outgoing.animate([fromOut, {opacity: 0, transform: 'translateY(' + (-direction * 6) + 'px)'}], {duration: 180, easing: 'ease-in', fill: 'both'}),
          incoming.animate([fromIn, {opacity: 1, transform: 'translateY(0)'}], {duration: 240, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both'})
        ];
        Promise.all(animations.map(function (animation) { return animation.finished; })).then(function () { if (version === revision) settle(); }).catch(function () {});
      }
      function render() {
        stop();
        if (toggle) {
          if (toggle.dataset.announcementPlaying !== String(playing)) {
            var template = bar.querySelector(playing ? '[data-announcement-pause-icon]' : '[data-announcement-play]');
            toggle.innerHTML = template ? template.innerHTML : playing ? 'Pause' : 'Play';
            toggle.dataset.announcementPlaying = String(playing);
          }
          toggle.setAttribute('aria-label', (playing ? 'Pause' : 'Play') + ' announcements');
          toggle.setAttribute('aria-pressed', String(playing));
        }
        if (live) live.setAttribute('aria-live', playing ? 'off' : 'polite');
        if (playing && !document.hidden && !reduce.matches && items.length > 1) timer = window.setInterval(function () {
          // Read the live state: a missed leave event must not latch autoplay off.
          if (!reduce.matches && !document.hidden && !bar.matches(':hover') && !bar.contains(document.activeElement)) show(current + 1, 1);
        }, 6000);
      }
      function move(delta) { playing = false; show(current + delta, delta); render(); }
      on(previous, 'click', function () { move(-1); });
      on(next, 'click', function () { move(1); });
      on(toggle, 'click', function () { playing = !playing; render(); });
      on(bar, 'mouseenter', render);
      on(bar, 'mouseleave', render);
      on(bar, 'focusin', render);
      on(bar, 'focusout', function (event) { if (!bar.contains(event.relatedTarget)) render(); });
      on(document, 'visibilitychange', function () { if (document.hidden) settle(); render(); });
      if (reduce.addEventListener) on(reduce, 'change', function () { settle(); render(); });
      bar._disposeShell = function () {
        stop(); settle(); cleanups.forEach(function (cleanup) { cleanup(); });
        delete bar.dataset.shellInit; delete bar.dataset.init; delete bar._disposeShell;
      };
      settle(); render();

    });
    root.querySelectorAll('[data-shell-mega]').forEach(function (item) {
      if (item.dataset.shellInit) return;
      item.dataset.shellInit = '1';
      var trigger = item.querySelector('[data-shell-mega-toggle]');
      var link = item.querySelector('.nav-link');
      var panel = item.querySelector('[data-shell-mega-panel]');
      var timer;
      function close(returnFocus) { window.clearTimeout(timer); panel.hidden = true; trigger.setAttribute('aria-expanded', 'false'); item.dataset.open = 'false'; if (returnFocus) trigger.focus(); }
      function open(focus) {
        window.clearTimeout(timer);
        document.querySelectorAll('[data-shell-mega]').forEach(function (other) { if (other !== item && other._shellClose) other._shellClose(false); });
        panel.hidden = false; trigger.setAttribute('aria-expanded', 'true'); item.dataset.open = 'true';
        if (focus) { var first = panel.querySelector('a'); if (first) first.focus(); }
      }
      item._shellClose = close;
      trigger.addEventListener('click', function () { if (panel.hidden) open(false); else close(false); });
      item.addEventListener('pointerenter', function (event) { if (event.pointerType === 'mouse' && window.matchMedia('(hover:hover) and (pointer:fine)').matches) { window.clearTimeout(timer); timer = window.setTimeout(function () { open(false); }, 160); } });
      item.addEventListener('pointerleave', function () { window.clearTimeout(timer); timer = window.setTimeout(function () { if (!item.contains(document.activeElement)) close(false); }, 200); });
      item.addEventListener('focusin', function () { window.clearTimeout(timer); });
      item.addEventListener('focusout', function (event) { if (!item.contains(event.relatedTarget)) close(false); });
      item.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); close(true); } else if (event.key === 'ArrowDown' && (event.target === trigger || event.target === link)) { event.preventDefault(); open(true); } });
    });
    root.querySelectorAll('[data-shell-mobile-toggle]').forEach(function (toggle) {
      if (toggle.dataset.shellInit) return;
      toggle.dataset.shellInit = '1';
      toggle.addEventListener('click', function () {
        var panel = document.getElementById(toggle.getAttribute('aria-controls'));
        var opening = panel.hidden;
        var menu = toggle.closest('[data-mobile-menu]');
        menu.querySelectorAll('[data-shell-mobile-toggle]').forEach(function (other) { var otherPanel = document.getElementById(other.getAttribute('aria-controls')); other.setAttribute('aria-expanded', 'false'); if (otherPanel) otherPanel.hidden = true; });
        panel.hidden = !opening;
        toggle.setAttribute('aria-expanded', String(opening));
        toggle.setAttribute('aria-label', (opening ? 'Collapse ' : 'Explore ') + toggle.closest('[data-shell-mobile-item]').querySelector('.mobile-navigation-primary').textContent.trim());
      });
    });
    root.querySelectorAll('[data-shell-accordion]').forEach(function (group) {
      if (group.dataset.shellInit) return;
      group.dataset.shellInit = '1';
      group.querySelectorAll('details').forEach(function (detail) { detail.addEventListener('toggle', function () { if (detail.open) group.querySelectorAll('details').forEach(function (other) { if (other !== detail) other.open = false; }); }); });
    });
    root.querySelectorAll('[data-shell-reviews]').forEach(function (section) {
      if (section.dataset.shellInit) return;
      section.dataset.shellInit = '1';
      var records = Array.from(section.querySelectorAll('[data-review-record]'));
      if (!records.length) return;
      var list = section.querySelector('[data-review-list]');
      var filter = section.querySelector('[data-review-filter]');
      var sort = section.querySelector('[data-review-sort]');
      var count = section.querySelector('[data-review-count]');
      var more = section.querySelector('[data-review-more]');
      var moreWrap = section.querySelector('[data-review-more-wrap]');
      var shown = 6;
      records.forEach(function (record, index) { record._featuredIndex = index; });
      function render() {
        var rating = filter ? filter.value : '';
        var order = sort ? sort.value : 'featured';
        var selected = records.filter(function (record) { return !rating || record.dataset.rating === rating; });
        if (order === 'highest' || order === 'lowest') selected.sort(function (a, b) { return (Number(a.dataset.rating) - Number(b.dataset.rating)) * (order === 'highest' ? -1 : 1); });
        else if (order === 'newest') selected.sort(function (a, b) { return (Date.parse(b.dataset.date) || 0) - (Date.parse(a.dataset.date) || 0); });
        else selected.sort(function (a, b) { return a._featuredIndex - b._featuredIndex; });
        records.forEach(function (record) { record.hidden = true; });
        selected.forEach(function (record, index) { record.hidden = index >= shown; list.appendChild(record); });
        count.textContent = selected.length + (rating ? ' ' + rating + '-star' : '') + (selected.length === 1 ? ' review' : ' reviews');
        if (moreWrap) moreWrap.hidden = selected.length <= shown;
      }
      if (filter) filter.addEventListener('change', function () { shown = 6; render(); });
      if (sort) sort.addEventListener('change', function () { shown = 6; render(); });
      if (more) more.addEventListener('click', function () { shown += 6; render(); });
      render();
    });
  }
  document.addEventListener('pointerdown', function (event) { document.querySelectorAll('[data-shell-mega]').forEach(function (item) { if (!item.contains(event.target) && item._shellClose) item._shellClose(false); }); });
  window.addEventListener('resize', function () { if (window.innerWidth < 1024) document.querySelectorAll('[data-shell-mega]').forEach(function (item) { if (item._shellClose) item._shellClose(false); }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { event.target.querySelectorAll('[data-shell-announcement]').forEach(function (bar) { if (bar._disposeShell) bar._disposeShell(); }); });
})();
